import { graphql } from "gatsby"
import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { MDXRenderer } from "gatsby-plugin-mdx"
import "./blog-post.css"

const MiniAppPostTemplate = ({ data }) => {
  const app = data.mdx
  const {
    title,
    description,
    date,
    status,
    stack,
    externalUrl,
    repoUrl,
  } = app.frontmatter

  return (
    <Layout activePage="finds">
      <SEO title={title} description={description || app.excerpt} />
      <div className="container">
        <div className="post-header fade-hero">
          <div className="page-eyebrow">{status || "MINI APP"}</div>
          <h1 className="post-title">{title}</h1>
          {description ? <p className="page-desc">{description}</p> : null}
          <div className="mini-app-meta">
            {date ? <span>{date}</span> : null}
            {stack ? <span>{stack}</span> : null}
            {externalUrl ? (
              <a href={externalUrl} target="_blank" rel="noreferrer">
                Open app
              </a>
            ) : null}
            {repoUrl ? (
              <a href={repoUrl} target="_blank" rel="noreferrer">
                View code
              </a>
            ) : null}
          </div>
        </div>

        <div className="post-body fade-content">
          <MDXRenderer>{app.body}</MDXRenderer>
        </div>
      </div>
    </Layout>
  )
}

export default MiniAppPostTemplate

export const pageQuery = graphql`
  query MiniAppBySlug($slug: String!) {
    mdx(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      body
      frontmatter {
        title
        date(formatString: "MMM DD, YYYY")
        description
        status
        stack
        externalUrl
        repoUrl
      }
    }
  }
`
